export default "__VITE_ASSET__C4yBirD9__"